import { authClient } from '@/utils/api'
import { OidcClientConfig } from '../types/authTypes'
import { queryOptions } from '@tanstack/react-query'

const getConfig = async (): Promise<OidcClientConfig> => {
  const { data } = await authClient.get(`/.well-known/openid-configuration`)
  return data
}

const getConfigOptions = () => {
  return queryOptions({
    queryKey: ['oidc-config'],
    queryFn: () => getConfig(),
  })
}

export { getConfig, getConfigOptions }
